import React from 'react'
import ErrorLoading from '../../../react/core/ErrorLoading'
import Loading from '../../../react/core/Loading'
import RecentJobs from '../../components/RecentJobs'
import { useGetJobBoardJobsQuery } from '../redux/query/jobBoardApi.slice'

/**
 * Renders a list of four recent jobs.
 * @returns {JSX.Element}
 */
export default function JobBoardRecentJobs () {
  const { data: jobs, isError, isLoading } = useGetJobBoardJobsQuery({ limit: 4, order_by: 'published_at', order_direction: 'DESC' })

  if (isError) {
    return <ErrorLoading />
  }

  if (isLoading) {
    return <Loading />
  }

  return <RecentJobs jobPostings={jobs.items}/>
}
